module.exports = __webpack_public_path__ + "static/media/draw-gift.d642a768.svg";